/** Pathname + query for opening an occurrence on the calendar page (deep link). */
export function buildCalendarOccurrencePath(occurrenceId) {
  const id = Number(occurrenceId);
  if (!Number.isFinite(id) || id <= 0) return "";
  return `/members/calendar?occurrenceId=${id}`;
}

/** Path for Event Auctions modal (dedicated deep link per occurrence). */
export function buildAuctionPath(occurrenceId) {
  const id = Number(occurrenceId);
  if (!Number.isFinite(id) || id <= 0) return "";
  return `/members/calendar/auctions/${id}`;
}

/** Full URL for Event Auctions deep link. */
export function buildAuctionLink(occurrenceId) {
  const path = buildAuctionPath(occurrenceId);
  if (!path) return "";
  return `${window.location.origin}${path}`;
}

/** Stable full URL (navigation, mentions). */
export function buildCalendarOccurrenceLink(occurrenceId) {
  const path = buildCalendarOccurrencePath(occurrenceId);
  if (!path) return "";
  return `${window.location.origin}${path}`;
}

/**
 * Full URL for copy/share (Discord link previews).
 * Appends a unique `v` param so each paste triggers a fresh OG scrape.
 */
export function buildCalendarOccurrenceShareLink(occurrenceId) {
  const path = buildCalendarOccurrencePath(occurrenceId);
  if (!path) return "";
  const bust = `v=${Date.now()}`;
  const separator = path.includes("?") ? "&" : "?";
  return `${window.location.origin}${path}${separator}${bust}`;
}

/** Parse `/members/calendar/auctions/:occurrenceId` from a pathname. */
export function parseAuctionOccurrenceIdFromPath(pathname) {
  const match = String(pathname || "").match(/^\/members\/calendar\/auctions\/(\d+)\/?$/);
  if (!match) return null;
  const id = Number(match[1]);
  return Number.isFinite(id) && id > 0 ? id : null;
}
